var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestaurantNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 15,
    height: 13,
    rx: 2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3C1 1.89543 1.89543 1 3 1H14C15.1046 1 16 1.89543 16 3V4.3H1V3Z",
    fill: "#5062F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 3C1 1.89543 1.89543 1 3 1H11.3125H14C15.1046 1 16 1.89543 16 3V4.25V12C16 13.1046 15.1046 14 14 14H3C1.89543 14 1 13.1046 1 12V3Z",
    stroke: "#5062F0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M11.1409 14.291L11.1409 2.47283",
    stroke: "#5062F0",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M8.83325 14.291L8.83325 2.47283",
    stroke: "#5062F0",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M6.52563 14.291L6.52563 2.47283",
    stroke: "#5062F0",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M13.4487 14.291L13.4487 2.47283",
    stroke: "#5062F0",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M1 6.51514L15.6667 6.51514",
    stroke: "#5062F0",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M1 8.87891L15.6667 8.87891",
    stroke: "#5062F0",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M1 11.2422L15.6667 11.2422",
    stroke: "#5062F0",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurantNetwork);
export default __webpack_public_path__ + "static/media/restaurantNetwork.8d794b0a46bc2a6d64762571320cb606.svg";
export { ForwardRef as ReactComponent };